<div *transloco="let t; prefix: 'shared.pagination'">
  <nav class="pagination-wrapper justify-center">
    <a [routerLink]="[]" queryParamsHandling="merge" [queryParams]="{page: currentPage - 1}" class="text-gray-700 hover:text-primary-600 flex items-center justify-center"
       [class.pointer-events-none]="currentPage === 1">
      <i class="icon-chevron-left"></i>
    </a>

    <div class="flex flex-row items-center">
      <ng-container *ngFor="let item of getPaginationRange()">
        <ng-container *ngIf="item !== '...'">
          <a [routerLink]="[]" queryParamsHandling="merge" [queryParams]="{page: item}" class="pagination-button"
             [ngClass]="{'active': item === currentPage}">
            {{ item }}
          </a>
        </ng-container>
        <ng-container *ngIf="item === '...'"><span class="pagination-button more">...</span></ng-container>
      </ng-container>
    </div>

    <a [routerLink]="[]" queryParamsHandling="merge"  [queryParams]="{page: currentPage + 1}" class="text-gray-700 hover:text-primary-600 flex items-center justify-center"
       [class.pointer-events-none]="currentPage === totalPages">
      <i class="icon-chevron-right"></i>
    </a>
  </nav>

  <div class="text-center font-semibold text-gray-700 mt-4">
    {{totalData}} {{t("results")}} ({{pageRange.start}}-{{pageRange.end}})
  </div>
</div>
